import { render } from "./StarRating.vue?vue&type=template&id=128023a5&scoped=true"
import script from "./StarRating.vue?vue&type=script&lang=js"
export * from "./StarRating.vue?vue&type=script&lang=js"

import "./StarRating.vue?vue&type=style&index=0&id=128023a5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128023a5"]])

export default __exports__